// Material Kit 2 React pages
import OurTeam from "pages/LandingPages/OurTeam";

export default function OurTeamPage() {
  return <OurTeam />;
}
